import React from 'react';
export function Footer() {
  return <footer className="bg-slate-950 text-slate-400 py-12 border-t border-slate-900" data-id="element-75">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center" data-id="element-76">
        <div className="mb-4 md:mb-0" data-id="element-77">
          <span className="font-serif text-2xl font-bold text-white tracking-tight" data-id="element-78">
            Evantiq
            <span className="text-amber-500" data-id="element-79">.</span>
          </span>
          <p className="text-sm mt-2" data-id="element-80">AI-Powered Document Review & Analysis</p>
        </div>

        <div className="flex space-x-6 text-sm" data-id="element-81">
          <a href="#" className="hover:text-white transition-colors" data-id="element-82">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-83">
            Terms of Service
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-84">
            Contact
          </a>
        </div>

        <div className="mt-8 md:mt-0 text-sm text-slate-600" data-id="element-85">
          &copy; {new Date().getFullYear()} Evantiq. All rights reserved.
        </div>
      </div>
    </footer>;
}